import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';

const URL = '/v2/user-plans';

class UserPlanService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<unknown>> {
    return axios.get(`${URL}`, config);
  }

  static patch(id: number, data: unknown, config?: AxiosRequestConfig): Promise<DataResponse<unknown>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }
}

export { UserPlanService };
